/**
 * This class is used by both the buyNow and changePlan controllers
 *
 * Author: Oded Sagir
 * @param  Object require -for adding dependencies
 * @return Object         -Class Object
 */
define(function(require) {
    'use strict';

    var LE = require('app');
    var Loader = require("ui/loader/Loader");
    var LEConfig = require("assets/config/le-env-conf");
    var errorCodes = require("registration-assets/data/errorCodes.json");
    var mockData = require("registration-assets/data/mockData.json");
    var ApiResources = require("assets/data/apiResources.json");

    // VIEW
    var Page = require("ui.components/page/Page");
    var CheckoutView = require("registration-views/CheckoutView");

    // COLLECTION
    var BaseCollection = require("collections/BaseCollection");
    var PlansCollection = require('registration-collections/PlansCollection');

    // MODEL
    var BaseModel = require("models/BaseModel");
    var ZuoraIFrameSourceModel = require("registration-models/ZuoraIFrameSourceModel");
    var BillingDetailsModel = require("registration-models/BillingDetailsModel");
    var BillingPricingModel = require("registration-models/BillingPricingModel");
    var BillingCRMDetailsModel = require("registration-models/BillingCRMDetailsModel");
    var InvoicesModel = require("registration-models/InvoicesModel");

    // UTILS
    var RegistrationStorageUtil = require("registration-utils/RegistrationStorageUtil");
    var CountryUtility = require("infra-util/CountryUtility");
    var DateUtility = require("utils/DateUtility");


    var BillingManager = {};
    LE.module("LERegistration", function (LERegistration, LE, Backbone, Marionette, $, _) {
        BillingManager = Marionette.Controller.extend({

            initialize: function (options) {
                this.vent = options.vent;
                this.controller = options.controller;

                this.zuoraIFrameSourceModel = new ZuoraIFrameSourceModel();
                this.routeToHomeForMyAccountFailWhenJustPurchased= false;

                this.mockit= false;
            },


            //-------------------------------------------------------------------------


            fetchZuoraIframeSource: function (flowModel, isRetainValues, errors, flowType){
                LERegistration.logger.info("start", "BillingManager:fetchZuoraIframeSource");
                this.zuoraIFrameSourceModel.clear();
                this.zuoraIFrameSourceModel.unset();
                var billingZouraHostedPageId = LEConfig.billingZouraHostedPageId[flowType][this.controller.flowModel.get("language")];
                if (!billingZouraHostedPageId){
                    billingZouraHostedPageId = LEConfig.billingZouraHostedPageId[flowType]['en-US'];
                }
                this.zuoraIFrameSourceModel.set("pageId", billingZouraHostedPageId);

                this.zuoraIFrameSourceModel.save(null, {
                    headers : {
                        'Content-Type': 'application/json'
                    },
                    success: _.bind(function (){
                        try {
                            var extraQueryParams = "";

                            if (flowModel.get("crmDetails.email") &&
                                flowModel.get("crmDetails.firstName") &&
                                flowModel.get("crmDetails.lastName")) {
                                // append to zuora iframe query params
                                extraQueryParams += "&field_email=" + flowModel.get("crmDetails.email") +
                                    "&field_creditCardHolderName=" + flowModel.get("crmDetails.firstName") + " " + flowModel.get("crmDetails.lastName");

                                    if(CountryUtility.translate2DigitTo3DigitCode(flowModel.get("location"))){
                                        extraQueryParams += "&field_creditCardCountry=" + CountryUtility.translate2DigitTo3DigitCode(flowModel.get("location"));
                                    } else if( flowModel.get("crmDetails.country") ) {
                                        extraQueryParams += "&field_creditCardCountry=" + CountryUtility.getCountryCodeByName(flowModel.get("crmDetails.country"));
                                    }
                            }

                            var zuoraIframeSrc = this.zuoraIFrameSourceModel.get("zuoraHostedPageSource") + "";

                            var queryParams = isRetainValues ? "&retainValues=true" : extraQueryParams;
                            flowModel.set({"zuoraIFrameSource": zuoraIframeSrc + encodeURI(queryParams)});
                            flowModel.set({"zuoraPostmessageURL": LEConfig.zuoraPostmessageURL});
                            var pagePermutation = Page.PERMUTATION.Custom;
                            if(LE.sessionManager.isAuthenticated()) {
                                pagePermutation = Page.PERMUTATION.Dialog;
                            }
                            var checkoutView = new CheckoutView({model: flowModel, errors: errors, flowType: flowType});
                            var CheckoutViewPage = new Page({
                                moduleName:LERegistration.moduleName,
                                context:LE.context,
                                view: checkoutView,
                                permutation: pagePermutation
                            });
                            this.controller.closeLoader();
                            // ZUORA PAGE HAS TIMED OUT
                            this.listenTo(checkoutView, CheckoutView.TRIGGERING.HOSTED_PAGE_TIMEDOUT, _.bind(function(flowType){
                                var returnPage= "buyNow";
                                if(flowType === "changePlan"){
                                    returnPage= "changePlanSelection";
                                }
                                this.controller.handleRegistrationError("Zuora after submit callback hasn't been fired", errorCodes.zuoraSubmitHasTimedOut, returnPage);
                            },this));
                            // on checkout cancel button click
                            this.listenTo(checkoutView, CheckoutView.TRIGGERING.CANCEL_BUTTON_CLICKED, _.bind(function(){
                                this.controller.routeToPrevious();
                            },this));
                            // on checkout next button click
                            this.listenTo(checkoutView, CheckoutView.TRIGGERING.NEXT_BUTTON_CLICKED, _.bind(function(checkoutData){
                                if(LE.sessionManager.isAuthenticated()) {
                                    this.controller.flowModel.set({"creditCardRef": checkoutData.pmi});
                                    LERegistration.controller.changePlanController.showPlanSelectionConfirmation();
                                }
                                else {
                                    this.controller.flowModel.set({"creditCardRef": checkoutData.pmi});
                                    LERegistration.controller.buyNowController.showBuyNowConfirmation();
                                }
                            },this));
                            // on Hosted Page Validation Error
                            this.listenTo(checkoutView, CheckoutView.TRIGGERING.HOSTED_PAGE_VALIDATION_FAILED,  _.bind(function (errors){
                                this.fetchZuoraIframeSource(this.controller.flowModel, true, errors, flowType);
                            },this));
                            this.controller.showViewInMainRegion(CheckoutViewPage);
                        } catch(ex) {
                            var message= "Error in success callback for fetching Zuora IFrame";
                            var returnPage= (LE.sessionManager.isAuthenticated() ? "changePlanSelection" : RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW);
                            this.controller.handleRegistrationError(message, errorCodes.dataFetchFailed, returnPage, { "zuoraIFrameSourceModel": this.zuoraIFrameSourceModel, "exception": ex });
                        }
                    }, this),
                    error: _.bind(function(model, response, options) {
                        var message= "Failed fetching Zuora IFrame ";
                        var errorCode= errorCodes.fetchZuoraIframeSourceFailed;
                        var returnPage= (LE.sessionManager.isAuthenticated() ? "changePlanSelection" : RegistrationStorageUtil.CONSTANT.RETURN_PAGE_BUYNOW);

                        this.controller.handleRegistrationError(message, errorCode, returnPage, null, response);
                    }, this)
                });
            },

            /**
             * fetches the selected plan rate
             * in case already exists in the plans collection query it from there
             * saving a net call.
             * looks for a planName attr in flowModel to be used to fetch the plan details
             * and set it under the currentPlan attr of the flowModel.
             * @param  {[type]} flowModel         [description]
             * @param  {[type]} force     do the ajax regardless of collection existing
             * @return {[type]}                   [description]
             *
             */
            getPlanDetailsByFlowModelPlanName: function (flowModel, deferred, force) {
                flowModel= flowModel || this.controller.flowModel;

                // first look it up in your plans collection if it already been loaded
                var plans= flowModel.get("collection"), plan= plans && plans.findWhere({"productRatePlanName" : flowModel.get("planName")});
                if(plan){
                    flowModel.set({"currentPlan": plan.attributes});
                    deferred= deferred || $.Deferred();
                    deferred.resolve(flowModel);
                    return deferred.promise();
                }else{
                // if collection strategy failed try the rateplan api
                    deferred= this._getData( flowModel, deferred, "currentPlan", new BillingPricingModel(), force );
                    return deferred;
                }
            },

            getCreditCardDetails: function(flowModel, deferred){
                deferred= deferred || $.Deferred();
                flowModel= flowModel || this.controller.flowModel;

                var ccDeferred= this._getData( flowModel, null, "creditCardDetails", new BillingDetailsModel() );
                $.when(ccDeferred)
                    .done(_.bind(function(){
                        var ccNum= flowModel.get("creditCardDetails.creditCardMaskNumber");
                        if(ccNum){
                            deferred.resolve(flowModel);
                        }else{
                            var message= "CreditCard Details returned value " + ccNum + " for creditCardMaskNumber";
                            deferred.reject(message, errorCodes.ccDetailsEmptyValues);
                        }
                    }, this))
                    .fail(_.bind(function(message, errorCode, response){
                        deferred.reject(message, errorCode, response);
                    },this));

                return deferred.promise();
            },

            getInvoices: function(flowModel){
                flowModel= flowModel || this.controller.flowModel;
                var deferred= this._getData( flowModel, null, "invoices", new InvoicesModel() );
                return deferred;
            },

            getBillingCRMDetails: function(flowModel, deferred){
                deferred= deferred || $.Deferred();
                flowModel= flowModel || this.controller.flowModel;

                var isTrialDeferred= this.isTrial();
                $.when(isTrialDeferred)
                    .done(_.bind(function(isTrial){
                        var mode= isTrial ? BillingCRMDetailsModel.MODES.TRIAL : BillingCRMDetailsModel.MODES.PAYING;
                        this._getData( flowModel, deferred, "crmDetails", new BillingCRMDetailsModel({mode: mode}) );
                    }, this))
                    .fail(_.bind(function(fModel, response, options){
                        var message= "error fetching crm data.";
                        LERegistration.logger.error(message, "BillingManager:getBillingCRMDetails", fModel);
                        deferred.reject(message, errorCodes.isTrialFailed, response);
                    },this));

                return deferred.promise();
            },

            /**
             * merges onto the flowModel the details fetched as specified by attributeName
             * currently handles crmDetails ; ccDetails and invoices,
             * Usage example:
             *   var deferred= this.controller.billingManager._getData(this.flowModel, deferred, attributeName, new SomeModel());
             *   $.when(deferred).done(_.bind(function(model){
             *       debugger;
             *   }, this)).fail(...);
             * @param  {[type]} crmModel [description]
             * @return {[type]}          [description]
             */
            _getData: function(flowModel, deferred, attributeName, model, force) {
                flowModel= flowModel || this.controller.flowModel;
                deferred = deferred || $.Deferred();

                if(flowModel === undefined){
                    deferred.reject("you have not passed a flow model to BillingManager._getData for fetching " + attributeName);
                    return deferred.promise();
                }

                // skip fetching if model attr already exists
                if(flowModel.get(attributeName) && force !== true){
                    deferred.resolve(flowModel);
                    return deferred.promise();
                }

                var options = {
                    success: _.bind(function(model2, response, options) {
                        if(response === null || response === undefined || response.status === 404){
                            errorHandler(attributeName, response || {});
                        }else{
                            LERegistration.logger.info("successfuly fetched " + attributeName + " for current user", "BillingManager:_geData");
                            flowModel.set(attributeName, model2.attributes);
                            deferred.resolve(flowModel);
                        }
                    }, this),
                    error: _.bind(function(model3, response, options) {
                        errorHandler(attributeName, response);
                    }, this),
                    creditCardRef: flowModel.get("creditCardRef"), //used for fetching BillingDetailsModel (Credit Card Details)
                    planName: flowModel.get("planName") //used for fetching BillingPricingModel (plan details)
                };

                function errorHandler(attributeName, response){
                    var errorCode= "";
                    var message= "error fetching " + attributeName;
                    LERegistration.logger.error(message, "BillingManager:_getData");
                    switch(attributeName){
                        case "crmDetails":
                            errorCode= errorCodes.crmDetailsFetchFailed;
                            break;
                        case "creditCardDetails":
                            errorCode= errorCodes.ccDetailsFetchFailed;
                            break;
                        case "invoices":
                            errorCode= errorCodes.invoicesFetchFailed;
                            break;
                        case "currentPlan":
                            errorCode= errorCodes.planFetchFailed;
                            break;
                    }
                    deferred.reject(message, errorCode, response);
                }

                model.fetch(options);
                return deferred.promise();
            },

            getCurrentAndAmmendedPlans: function(flowModel, deferred){
                flowModel= flowModel || this.controller.flowModel;
                deferred = deferred || $.Deferred();

                if(flowModel === undefined){
                    deferred.reject();
                    return deferred.promise();
                }

                if( flowModel.get("currentPlan") ){
                    deferred.resolve(flowModel);
                    return deferred.promise();
                }

                var isTrialDeferred= this.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    if(isTrial || isTrial === undefined){
                        deferred.reject("No Current Plan for a trial/unregistered user.", errorCodes.noCurrentPlanForTrial);
                        return;
                    }
                    var resource= _.clone(ApiResources.Billing.BillingCurrentAndAmmended);
                    resource.url = resource.url.replace("{accountId}", LE.loginInfo.accountId);
                    var myPlansCollection= new BaseCollection();
                    myPlansCollection.resource= resource;
                    myPlansCollection.fetch({
                        success: _.bind(function(collection, response, options){
                            this._setCurrentAndAmmendedPlans(flowModel, collection);
                            deferred.resolve(flowModel);
                        }, this),
                        error: _.bind(function(model, response, options){
                            if(response.status === 404){
                                deferred.reject("Current and Ammended Plan api returned 404.", errorCodes.currentPlanFetchFailed, response);
                            }else {
                                var message= "Failed fetching current plan data, getCurrentAndAmmendedPlans.";
                                var errorCode= errorCodes.currentPlanFetchFailed;
                                deferred.reject( message, errorCode, response);
                            }
                        }, this)
                    });
                }, this));

                return deferred.promise();
            },

            /**
             * getPlans depends on 2 deferrs: isTrial and usage.
             * @param  {[type]} flowModel [description]
             * @return {[type]}           [description]
             */
            getPlans:  function (flowModel, deferred){
                flowModel= flowModel || this.controller.flowModel;
                deferred = deferred || $.Deferred();

                if(flowModel === undefined){
                    deferred.reject();
                    return deferred.promise();
                }

                // skip fetching if collection model attr already exists
                if( flowModel.get("collection") ){
                    this._setCurrentAndAmmendedPlans(flowModel, flowModel.get("collection"));
                    deferred.resolve(flowModel);
                    return deferred.promise();
                }

                $.when(
                    $.Deferred(_.bind(function(deferred){
                        this.isTrial(true, deferred);
                    }, this))
                )
                .done(_.bind(function(isTrial){
                    $.when(
                        $.Deferred(_.bind(function(deferred){
                            //the roll of usage is just for passing to the plans api the usage param
                            if(isTrial){
                                this.getCreditsUsageForCurrentMonth(deferred);
                            }else{
                                this.getAverageMonthlyCreditsUsage(deferred);
                            }
                        }, this))
                    )
                    .always(_.bind(function(usage, errorCode, response){
                        //proceed without usage
                        /**
                         * failed calls will end up here aswell
                         * we'd be able to distinguish by having a 2 more arguments: errorCode and response
                         * usage will be an error message
                         * However we can still fetch plans without having this data
                         * NOTE A TRIAL THAT JUST TURNED PAYING WILL FAIL USAGE CALL
                         * HENCE WE DEFAULT USAGE TO 0
                         */
                        if(errorCode){
                            usage= 0;
                        }

                        var plansCollection = new PlansCollection({
                            usage: usage,
                            mode:  isTrial ? PlansCollection.MODES.TRIAL : PlansCollection.MODES.PAYING
                        });

                        plansCollection.fetch({
                            success: _.bind(function (collection, response, options){
                                if(response === undefined){
                                    var message= "Plans api hasn't responded";
                                    deferred.reject(message, errorCodes.plansFetchFailed);
                                    return;
                                }
                                flowModel.set("collection",collection);
                                this._setCurrentAndAmmendedPlans(flowModel, collection);
                                deferred.resolve(flowModel);
                            }, this),
                            error: _.bind(function (data, response, options){
                                var message= "error in fetching plans ";
                                var errorCode= errorCodes.plansFetchFailed;
                                deferred.reject(message, errorCode, response);
                            }, this)
                        });
                    },this))
                    .fail(_.bind(function(message, errorCode, response){
                        // we parse the response for error by ourselves since it won't reach the handleRegistrationError
                        // function since the data is optional and does not result in an error page
                        var serverSaid= "Server said: " + (response && response.responseError && response.responseError.message) || response.statusText;
                        errorCode+= ":" + ((response.responseError && response.responseError.code) || response.status);
                        message= "Error fetching plans data, usage api call failed." + message + serverSaid + ". ErrorCode is: " + errorCode;
                        LERegistration.logger.error(message, "BillingManager:getPlans");
                    },this));
                },this))
                .fail(_.bind(function(message, errorCode, response){
                    message= "Cannot proceed to fetching plans since isTrial failed." + message;
                    deferred.reject(message, errorCode, response);
                },this));



                return deferred.promise();
            },

            _setCurrentAndAmmendedPlans: function(flowModel, plans){
                // Update flowModel.currentPlan to the current plan
                var planCurrent= plans && plans.findWhere({"planType" : PlansCollection.TYPES.CURRENT});
                if(planCurrent){
                    flowModel.set({"currentPlan": planCurrent.attributes});
                }
                var planAmendement= plans && plans.findWhere({"planType" : PlansCollection.TYPES.AMENDMENT});
                if(planAmendement){
                    flowModel.set({"amendedPlan": planAmendement.attributes});
                }
            },

            /**DEPRECATED/UNUSED
             * receives a flowModel obj and fills it with:
             * crmDetails; currentPlan; ammendedPlan; collection; invoices; and creditCardDetails
             * @param  {[type]} flowModel [description]
             * @return {[type]}           [description]
             */
            getFlowModelDetails: function(flowModel, deferred){
                flowModel= flowModel || this.controller.flowModel;
                var mainDeferred = deferred || $.Deferred();

                var isTrialDeferred= this.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    // 3 parallel deferrs
                    $.when(
                        // Plans Collection; Ammendment and Current Plan Details
                        $.Deferred(_.bind(function(deferred){
                            this.getPlans( flowModel, deferred);
                        }, this)),
                        // CRM Details
                        $.Deferred(_.bind(function(deferred){
                            var mode= isTrial ? BillingCRMDetailsModel.MODES.TRIAL : BillingCRMDetailsModel.MODES.PAYING;
                            this._getData( flowModel, deferred, "crmDetails", new BillingCRMDetailsModel({mode: mode}) );
                        }, this)),
                        // CreditCard Details
                        $.Deferred(_.bind(function(deferred){
                            if(isTrial){
                                // Trial Account- hence no BillngPricing(Current Plan) and no CreditCardDetails
                                deferred.resolve(flowModel);
                            }else{
                                this._getData( flowModel, deferred, "creditCardDetails", new BillingDetailsModel() );
                            }
                        }, this)),
                        // Invoices Details
                        $.Deferred(_.bind(function(deferred){
                            this._getData( flowModel, deferred, "invoices", new InvoicesModel() );
                        }, this))
                    )
                    .done(_.bind(function(plans, crmDetails, creditCardDetails, invoices){
                        mainDeferred.resolve(flowModel);
                    },this))
                    .fail(_.bind(function(message, errorCode, response){
                        message= "Error fetching all data." + message;
                        mainDeferred.reject(message, errorCode, response);
                    },this));
                }, this));

                return mainDeferred.promise();
            },

            /**
             * returns a deferred object and the resolved function recieves the isTrial boolean
             * on another level you will sometimes want to test for
             * (LE.context.get("user.isTrial") === false && LE.context.get("user.remainingDays") < 0)
             * @return {Boolean} [description]
             */
            isTrial: function(verboseIsTrial, deferred) {
                deferred = deferred || $.Deferred();

                //return undefined if the user does not exists as in buynow flow
                if(!LE.sessionManager.isAuthenticated()){
                    deferred.resolve();
                }else{
                    if(LE.context.get("user.isTrialAttrSet")){
                        deferred.resolve(LE.context.get("user.isTrial"));
                    }else{
                        if(LE.context.get("user.isTrialAttrSetError")){
                            LE.BillingInformation();   // retry
                            trialError(this, verboseIsTrial);
                        }else{
                            LE.context.once('change:user.isTrialAttrSet', function(){
                                deferred.resolve(LE.context.get("user.isTrial"));
                            });
                            LE.context.once('change:user.isTrialAttrSetError', _.bind(function(){
                                if( LE.context.get("user.isTrialAttrSetError") ){
                                    trialError(this, verboseIsTrial);
                                }else{
                                    deferred.resolve(LE.context.get("user.isTrial"));
                                }
                            },this));
                        }
                    }
                }

                return deferred.promise();

                function trialError(that, verboseIsTrial){
                    var inRegModule= window.location.hash.indexOf("#registration") === 0 || verboseIsTrial;
                    if(inRegModule){
                        var message= "Failed api isTrial.";
                        var errorCode= errorCodes.isTrialFailed;
                        deferred.reject(message, errorCode);
                    }
                }
            },

            getCreditsUsageForCurrentMonth: function(deferred){
                deferred = deferred || $.Deferred();

                // if(this.mockit){
                //     this.creditsUsageForCurrentMonth= 22; //Mock usage, crunched into accumilated value
                // }

                if(_.isUndefined(this.creditsUsageForCurrentMonth)){
                    var isTrialDeferred= this.isTrial();
                    $.when(isTrialDeferred).done(_.bind(function(isTrial){
                        if(isTrial === undefined){
                            deferred.reject("No site to check usage for.", errorCodes.usageFetchFailed);
                            return;
                        }
                        var resource= _.clone(ApiResources.Billing.BillingUsage);
                        resource.url = resource.url.replace("{accountId}", LE.loginInfo.accountId);
                        var usageModel= new BaseModel();
                        usageModel.resource= resource;
                        usageModel.fetch({
                            success: _.bind(function(model, response, options){
                                var totalUsage= _.reduce(response.usage, function(memo, item){
                                    return memo + item.utilization;
                                }, 0);
                                totalUsage= Math.round(totalUsage);

                                this.creditsUsageForCurrentMonth= {
                                    totalUsage: totalUsage, //LE.context.get("reporting.numOfEngagements");
                                    detailedUsage: response.usage
                                };
                                this.controller.flowModel.set({"engagementUsage": this.creditsUsageForCurrentMonth.totalUsage});

                                this.trigger(BillingManager.TRIGGERING.CHANGED_CREDITS_USAGE, this.creditsUsageForCurrentMonth);
                                deferred.resolve(this.creditsUsageForCurrentMonth.totalUsage);
                            }, this),
                            error: _.bind(function(model, response, options){
                                if(response.status === 404){
                                    deferred.reject("Usage api returned 404.", errorCodes.usageFetchFailed, response);
                                }else {
                                    var message= "Failed fetching usage data, CreditsUsageForCurrentMonth.";
                                    var errorCode= errorCodes.usageFetchFailed;
                                    deferred.reject( message, errorCode, response);
                                }
                            }, this)
                        });
                    }, this));
                }else{
                    deferred.resolve(this.creditsUsageForCurrentMonth.totalUsage);
                }

                return deferred.promise();
            },

            /**
             * based on the average of a paying customer last 3 invoices
             * @param  {[type]} deferred [description]
             * @return {[type]}          [description]
             */
            getAverageMonthlyCreditsUsage: function(deferred){
                deferred = deferred || $.Deferred();

                if(_.isUndefined(this.averageMonthlyCreditsUsage)){
                    var isTrialDeferred= this.isTrial();
                    $.when(isTrialDeferred).done(_.bind(function(isTrial){
                        var resource= _.clone(ApiResources.Billing.BillingUsageInvoices);
                        resource.url = resource.url.replace("{accountId}", LE.loginInfo.accountId);
                        var usageModel= new BaseModel();
                        usageModel.resource= resource;
                        usageModel.fetch({
                            success: _.bind(function(model, response, options){
                                this.averageMonthlyCreditsUsage= (response && response.usage) || 0;
                                //will return -1 if no data
                                deferred.resolve(this.averageMonthlyCreditsUsage);
                            }, this),
                            error: _.bind(function(model, response, options){
                                if(response.status === 404){
                                    deferred.reject("AVERAGE Usage api returned 404.", errorCodes.averageUsageFetchFailed, response);
                                }else {
                                    var message= "Failed fetching usage data, averageMonthlyCreditsUsage.";
                                    var errorCode= errorCodes.averageUsageFetchFailed;
                                    deferred.reject( message, errorCode, response);
                                }
                            }, this)
                        });
                    }, this));
                }else{
                    deferred.resolve(this.averageMonthlyCreditsUsage);
                }

                return deferred.promise();
            },

            getTerm: function(deferred){
                deferred = deferred || $.Deferred();

                var term=  "";

                var isTrialDeferred= this.isTrial();
                $.when(isTrialDeferred).done(_.bind(function(isTrial){
                    if (isTrial || isTrial === undefined || this.mockit){
                        var cycle= this.controller.flowModel.get('pendingPlan.baseBillingFrequencyMonths');
                        cycle= cycle === 1 ? 12 : cycle;
                        term= LE.translator.translate("LERegistration.planSelection.term.initial").replace("{0}", cycle);
                        deferred.resolve(term);
                        return;
                    }

                    var resource= _.clone(ApiResources.Billing.BillingTerm);
                    resource.url = resource.url.replace("{accountId}", LE.loginInfo.accountId);
                    resource.url = resource.url.replace("{planName}", this.controller.flowModel.get('planName')); //amended plan name, eg: 100/Monthly
                    resource.url = resource.url.replace("{productName}", this.controller.flowModel.get('productName') || "LiveEngage");
                    var termModel= new BaseModel();
                    termModel.resource= resource;
                    termModel.fetch({
                        success: _.bind(function(model, response, options){
                            if(response){
                                // {"autoRenew": true,"initialTerm": 12,"renewalTerm": 12,"termStartDate": 1425220935000,"termType": "TERMED","activeFromDate": "2015-03-01","currentTerm": "12"}
                                var future, date;
                                //future to be term
                                if(response.initialTerm){
                                    future= response.initialTerm;
                                    future= future === 1 ? 12 : future;
                                }

                                if(response.activeFromDate){
                                    date= DateUtility.strToDateObj(response.activeFromDate);
                                    date= DateUtility.getDateToShow(date);
                                }

                                //check if no change in term
                                if(future){
                                    //Your new term will be updated to 13 months. And your amended plan will be effective 1. Jun 2015
                                    term= LE.translator.translate("LERegistration.planSelection.term.amendedWithTerm").replace("{0}", future).replace("{1}", date);
                                }else{
                                    term= LE.translator.translate("LERegistration.planSelection.term.amendedWithoutTerm").replace("{0}", date);
                                }
                            }
                            deferred.resolve(term);
                        }, this),
                        error: _.bind(function(model, response, options){
                            if(response.status === 404){
                                deferred.reject("Term calculator returned 404.", errorCodes.termFetchFailed, response);
                            }else {
                                var message= "Failed fetching term data.";
                                var errorCode= errorCodes.termFetchFailed;
                                deferred.reject( message, errorCode, response);
                            }
                        }, this)
                    });
                }, this));

                return deferred.promise();
            },


            addLpTagVar: function() {
                LE.lpTagAddVar([
                    {name:"callForAction_isFirstTimeLogin", val: LE.isFirstTimeLogin() ? "yes" : "no"},
                    {name:"callForAction_persona", val: LE.sessionManager.getPersonas().join(",")},
                    {name:"callForAction_hasMigratingFeature", val: LE.sessionManager.hasMigratingFeature() ? "yes" : "no"}
                ]);

                var promises= [];
                promises.push(this.getCurrentAndAmmendedPlans());
                promises.push(this.getCreditsUsageForCurrentMonth());
                $.when.apply($, promises)
                    .always(_.bind(function() {
                        // has currentPlan: includeUnits
                        if( this.controller.flowModel.get('currentPlan') ){
                            var currentPlanIncludedUnits = this.controller.flowModel.get("currentPlan.includedUnits");
                            LE.lpTagAddVar([
                                {name:"callForAction_currentPlan", val: currentPlanIncludedUnits}
                            ]);
                        }
                        // has usage: usage details and total
                        if( this.creditsUsageForCurrentMonth ){
                            //details
                            var detailedUsageList= [];
                            _.each(this.creditsUsageForCurrentMonth.detailedUsage, function(item){
                                detailedUsageList.push({name: "callForAction_" + item.engagementName + "_usage" , val: item.utilization});
                            });
                            LE.lpTagAddVar(detailedUsageList);

                            //total
                            LE.lpTagAddVar([
                                {name:"callForAction_totalUsage", val: this.creditsUsageForCurrentMonth.totalUsage }
                            ]);
                        }
                    },this))
                    .done(_.bind(function(flowModel, usage) {
                        // has both currentPlan and usage
                        var currentPlanIncludedUnits= flowModel.get("currentPlan.includedUnits");
                        var usagePercentage= Math.round( 100 * usage / currentPlanIncludedUnits);
                        LE.lpTagAddVar([
                            {name:"callForAction_engagementUsagePercent", val: usagePercentage}
                        ]);
                    },this))
                    .fail(_.bind(function(message, errorCode, response) {
                        message+= "Failed loading currentPlan and usage to calculate LPTagVars.";
                        LERegistration.logger.error(message);
                    },this));
            }

        });



    });

    BillingManager.TRIGGERING= {
        CHANGED_CREDITS_USAGE: "ChangedCreditsUsageForCurrentMonth"
    };
    return BillingManager;
});
